import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { InputSearch } from "components/Atomos/Form/Elements/InputSearch";
import { getInformativesGeojsonRequest } from "store/modules/ouvidoria/informativo/actions/getInformativesGeojson";
import { Alert, Box, Skeleton, VStack, Text, HStack } from "@chakra-ui/react";
import { useTypedSelector } from "store/hooks";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { IconButtonGray } from "components/Atomos/Buttons/IconButtonGray";
import { ToLatLngBound } from "utils/map/converters/BoundConverter";
import { useMap } from "react-leaflet";
import { RiArrowRightLine } from "react-icons/ri";

export function TabInformativos() {
  const map = useMap();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");

  const { isRequesting: loadingInformatives, successPayload: informatives } =
    useTypedSelector(
      (state) => state.ouvidoria.informativo.getInformativesGeojson
    );

  useEffect(() => {
    dispatch(getInformativesGeojsonRequest({ search }));
  }, [search]);

  return (
    <Box>
      <InputSearch size="sm" onChangeValue={setSearch} />
      {!loadingInformatives && informatives?.features.length === 0 && (
        <Alert status="info" fontSize="sm" mt="2">
          Nenhum informativo encontrado.
        </Alert>
      )}
      {loadingInformatives ? (
        <VStack pt="4" spacing={8}>
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <VStack key={i} w="full">
                <Skeleton height="20px" w="full" />
                <Skeleton height="40px" w="full" />
              </VStack>
            ))}
        </VStack>
      ) : (
        <Box>
          {informatives?.features?.map((feature) => {
            const prop = feature.properties;
            return (
              <Box
                key={feature.properties.id}
                w="full"
                borderBottom="thin"
                borderBottomStyle="solid"
                borderBottomColor={"gray.100"}
                px="2"
              >
                <HStack>
                  <VStack
                    p={2}
                    spacing={0}
                    justify="flex-start"
                    align="flex-start"
                  >
                    <Text fontSize="md" fontWeight="medium">
                      {prop.titulo}
                    </Text>

                    <TextGray fontSize="sm" noOfLines={2}>
                      Endereço: {prop.endereco.logradouro},{" "}
                      {prop.endereco.bairro} - {prop.endereco.municipio}
                    </TextGray>
                  </VStack>
                  <Box>
                    <IconButtonGray
                      onClick={() => {
                        if (feature.bbox) {
                          map.flyToBounds(ToLatLngBound(feature.bbox), {
                            animate: false,
                            maxZoom: 19
                          });
                        }
                      }}
                      size="sm"
                      icon={<RiArrowRightLine />}
                      aria-label="Selecionar zoneamento"
                    />
                  </Box>
                </HStack>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
